import React from "react";
import ContentCard, { ContentCardProps } from "../../shared/ContentCard";

interface MoreInfoTabProps {}

const MoreInfoTab: React.FC<MoreInfoTabProps> = (props) => {
  const content: Array<ContentCardProps> = [
    { title: "Allergene", text: "Soybeans, Milk" },
    { title: "Allergene", text: "Soybeans, Milk" },
  ];
  return (
    <div className="content-card-wrap">
      {content.map((data, index) => (
        <ContentCard key={index} title={data.title} text={data.text} />
      ))}
    </div>
  );
};

export default MoreInfoTab;
